<template>
	<div class="content_box">
		<div class="title">
			<span class="left_shu"></span>
			任务调度
		</div>
		<div class="page_top_box">
			<el-button type="primary" icon="el-icon-circle-plus-outline"
				style="background-color: #F65600;border: none;margin-left: auto;" @click="show">
				分配任务</el-button>
		</div>
		<div class="table_box">
			<el-table :data="tableData" style="width: 100%;">
				<el-table-column prop="carNo" label="车辆编号" align='center'>
				</el-table-column>
				<el-table-column prop="carName" label="车辆名称" align='center'>
				</el-table-column>
				<el-table-column prop="routeName" label="路线名称" align='center'>
				</el-table-column>
				<el-table-column prop="description" label="描述" align='center'>
				</el-table-column>
				<el-table-column prop="state" label="状态" align='center'>
					<template slot-scope="scope">
						{{scope.row.state==0?'已创建':scope.row.state==1?'执行中':scope.row.state==2?'已暂停':scope.row.state==3?'已取消':'已完成'}}
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" align='center'>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align='center'>
					<template slot-scope="scope">
						<!-- <el-button @click="inspection(scope.row)" type="text" size="small">巡检</el-button> -->
						<el-button v-if="scope.row.state==0||scope.row.state==3||scope.row.state==4"
							@click="implement(scope.row)" type="text" size="small">执行任务</el-button>
						<el-button v-if="scope.row.state==1" @click="suspend(scope.row)" type="text" size="small">暂停
						</el-button>
						<el-button v-if="scope.row.state==2" @click="recovery(scope.row)" type="text" size="small">恢复
						</el-button>
						<el-button v-if="scope.row.state==1||scope.row.state==2" @click="cancel(scope.row)" type="text"
							size="small">结束
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="table_paging">
				<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
					:total="currentTotal" background layout="prev, pager, next">
				</el-pagination>
			</div>
		</div>
		<div class="model" v-if="modelShow">
			<div class="mask"></div>
			<div class="model-dialog" v-loading="loading" element-loading-text="创建中"
				element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
				<div class="model-header">
					<span>{{title}}</span>
					<i class="el-icon-close" @click="hide"></i>
				</div>
				<div class="model-body">
					<el-form ref="form" :model="form" label-width="80px">
						<el-form-item label="选择路线" label-width='100px'>
							<el-select v-model="form.routeId" placeholder="请选择路线">
								<el-option v-for="item in routeList" :key="item.name" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="描述" label-width='100px'>
							<el-input type="textarea" v-model="form.description"></el-input>
						</el-form-item>
					</el-form>
				</div>
				<div class="model-footer">
					<div class="left-btn" @click="onSubmit">确认</div>
					<div class="right-btn" @click="hide">取消</div>
				</div>
			</div>
		</div>
		<div class="model" v-if="modelShow2">
			<div class="mask"></div>
			<div class="model-dialog" v-loading="loading2" element-loading-text="执行任务中"
				element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
				<div class="model-header">
					<span>输入密码</span>
					<i class="el-icon-close" @click="hide2"></i>
				</div>
				<div class="model-body">
					<el-input v-model="password" placeholder="请输入密码"></el-input>
				</div>
				<div class="model-footer">
					<div class="left-btn" @click="onSubmit2">确认</div>
					<div class="right-btn" @click="hide2">取消</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				title: '', //弹框文字
				tableData: [], //数据
				currentPage: 1, //页数
				pageSize: 10, //每页数量
				currentTotal: 0, //总数
				modelShow: false, //弹框判断
				modelShow2: false, //弹框判断
				loading: false, //加载Loading
				loading2: false, //加载Loading
				form: {
					routeId: '', //车辆编号
					description: '', //描述
				},
				routeList: [], //路线列表
				taskId: '',
				password: '',
				timer: null, // 初始定时器变量名为null
			}
		},
		mounted() {
			this.start()
			this.getRouteList()
		},
		methods: {
			start() {
				// 将定时器名字赋值到变量中
				this.timer = setInterval(() => {
					console.log("开始---");
					this.getData()
				}, 3000);
			},
			end() {
				clearInterval(this.timer);
				this.timer = null // 这里最好清除一下，回归默认值
				// 众所周知，定时器返回一个随机整数，用于表示定时器的编号，后面通过名字可以取消这个定时器的执行。
				console.log(this.timer);
			},
			async getData() {
				let result = await this.request.post("/v1.0/drivingMission/getPageData", {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					type: 1,
				});
				this.tableData = result.data.dataList
				this.currentTotal = result.data.totalCount - 0
			},
			async getRouteList() {
				let result = await this.request.post("/v1.0/fixedRoute/getPageData", {
					pageNum: 1,
					pageSize: 100,
				});
				this.routeList = result.data.dataList
			},
			handleCurrentChange(val) {
				console.log(val)
				this.currentPage = val
				//点击下一页的时候 重新调用接口从后端取分页数据;{ current: this.currentPage } 为传给后端的字段
				this.getData()
			},
			show() {
				this.title = '分配任务'
				this.form = {}
				this.modelShow = true
			},
			hide() {
				this.modelShow = false
			},
			async onSubmit() {
				var that = this
				that.loading = true
				let result = await that.request.post("/v1.0/drivingMission/create", that.form);
				if (result.code == 0) {
					that.$message({
						type: 'success',
						message: '添加成功!'
					});
					that.loading = false
					that.modelShow = false
					that.getData()
				} else {
					that.loading = false
				}
			},
			implement(e) {
				this.taskId = e.id
				this.modelShow2 = true
			},
			hide2() {
				this.modelShow2 = false
				this.taskId = ''
			},
			suspend(e) {
				this.taskId = e.id
				this.control(1, '暂停成功!')
			},
			recovery(e) {
				this.taskId = e.id
				this.control(3, '恢复成功!')
			},
			cancel(e) {
				this.taskId = e.id
				this.control(2, '任务已结束!')
			},
			async control(controlType, message) {
				var that = this
				let result = await that.request.post("/v1.0/drivingMission/control", {
					id: that.taskId,
					controlType: controlType
				});
				if (result.code == 0) {
					that.$message({
						type: 'success',
						message: message
					});
					that.taskId = ''
					that.password = ''
					that.modelShow2 = false
					that.loading2 = false
					that.getData()
				} else {
					that.loading2 = false
				}
			},
			onSubmit2() {
				if (this.password != '123123') {
					this.$message({
						type: 'error',
						message: '密码错误'
					});
					return
				}
				this.loading2 = true
				this.control(0, '启动成功!')
			},
		},
		beforeDestroy: function() {
			this.end()
		}
	}
</script>

<style>
</style>
